import React , {Component} from 'react';
import {
    SkeletonBlock
} from 'framework7-react';

class OrderDetailsLoader extends Component{
    render(){
        return(
            <div id="order-details-loading" className="h-100 bg-white overflow-x-scroll">


                <div className="order-card-loading">
                    <div className="title">
                        <SkeletonBlock slot="media" effect={"blink"} className="skeleton-effect-blink"/>
                    </div>
                </div>


                <div className="order-card-loading">
                    <div className="title">
                        <SkeletonBlock slot="media" effect={"blink"} className="skeleton-effect-blink"/>
                    </div>
                </div>


                <div className="order-card-loading">
                    <div className="title">
                        <SkeletonBlock slot="media" effect={"blink"} className="skeleton-effect-blink"/>
                    </div>
                </div>


                <div className="order-card-loading">
                    <div className="title">
                        <SkeletonBlock slot="media" effect={"blink"} className="skeleton-effect-blink"/>
                    </div>
                </div>


                <div className="order-card-loading">
                    <div className="title">
                        <SkeletonBlock slot="media" effect={"blink"} className="skeleton-effect-blink"/>
                    </div>
                </div>


                <div className="order-card-loading">
                    <div className="title">
                        <SkeletonBlock slot="media" effect={"blink"} className="skeleton-effect-blink"/>
                    </div>
                </div>


                <div className="order-card-loading">
                    <div className="title">
                        <SkeletonBlock slot="media" effect={"blink"} className="skeleton-effect-blink"/>
                    </div>
                </div>


                <div className="order-card-loading">
                    <div className="title">
                        <SkeletonBlock slot="media" effect={"blink"} className="skeleton-effect-blink"/>
                    </div>
                </div>


            </div>
        )
    }
}

export default OrderDetailsLoader;